import React from "react";
import { useNavigate } from "react-router-dom";

export default function AntiSpamDemoPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(35px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes scanCircle {
          0% { transform: scale(0.8); opacity: 0.9; }
          100% { transform: scale(2.4); opacity: 0; }
        }

        @keyframes shieldPulse {
          0%,100% { transform: scale(1); box-shadow: 0 0 24px rgba(0,242,255,0.35); }
          50% { transform: scale(1.06); box-shadow: 0 0 70px rgba(0,242,255,0.85); }
        }

        @keyframes messageMove {
          0% { transform: translateX(-20px); opacity: 0; }
          30% { opacity: 1; }
          70% { opacity: 1; }
          100% { transform: translateX(20px); opacity: 0; }
        }

        @keyframes blockFlash {
          0%,100% { border-color: rgba(0,242,255,0.35); }
          50% { border-color: rgba(255,60,90,0.9); box-shadow: 0 0 45px rgba(255,60,90,0.45); }
        }

        @keyframes botShake {
          0%,100% { transform: rotate(0deg); }
          25% { transform: rotate(-6deg); }
          75% { transform: rotate(6deg); }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.wrapper}>
        <div style={styles.hero}>
          <span style={styles.scanOne}></span>
          <span style={styles.scanTwo}></span>

          <div style={styles.shield}>
            🛡️
          </div>

          <div style={styles.bot}>🤖</div>
          <div style={styles.block}>🚫</div>
        </div>

        <h1 style={styles.title}>Anti-spam intelligent</h1>

        <p style={styles.subtitle}>
          Notre algorithme aide les utilisateurs en détectant les comportements suspects
          pour garder une communauté plus saine.
        </p>

        <div style={styles.demoBox}>
          <div style={styles.messageOne}>Message normal accepté</div>
          <div style={styles.messageTwo}>Lien suspect détecté</div>
          <div style={styles.messageThree}>Spam bloqué automatiquement</div>
        </div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>🔎</div>
            <h3 style={styles.cardTitle}>Analyse</h3>
            <p style={styles.cardText}>Les messages suspects sont repérés rapidement.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🚫</div>
            <h3 style={styles.cardTitle}>Blocage</h3>
            <p style={styles.cardText}>Le spam est limité avant de gêner les utilisateurs.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🤝</div>
            <h3 style={styles.cardTitle}>Protection</h3>
            <p style={styles.cardText}>L’objectif est d’aider, protéger et garder l’échange propre.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%), radial-gradient(circle at bottom left, rgba(255,0,90,0.16), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    overflowY: "auto",
    textAlign: "center",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    zIndex: 20,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,0.45)",
    background: "rgba(0,12,20,0.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.25)",
  },

  wrapper: {
    maxWidth: 980,
    margin: "0 auto",
    paddingTop: 70,
    animation: "fadeUp 0.8s ease forwards",
  },

  hero: {
    width: 190,
    height: 190,
    margin: "0 auto 30px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  scanOne: {
    position: "absolute",
    width: 130,
    height: 130,
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,0.45)",
    animation: "scanCircle 2.4s infinite",
  },

  scanTwo: {
    position: "absolute",
    width: 130,
    height: 130,
    borderRadius: "50%",
    border: "2px solid rgba(255,60,90,0.35)",
    animation: "scanCircle 2.4s infinite 0.8s",
  },

  shield: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    background: "rgba(0,242,255,0.10)",
    border: "2px solid rgba(0,242,255,0.75)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 54,
    animation: "shieldPulse 2.3s infinite",
    zIndex: 3,
  },

  bot: {
    position: "absolute",
    right: 8,
    bottom: 28,
    fontSize: 36,
    animation: "botShake 0.8s infinite",
    zIndex: 4,
  },

  block: {
    position: "absolute",
    right: 0,
    bottom: 18,
    fontSize: 34,
    zIndex: 5,
  },

  title: {
    margin: "0 0 14px",
    fontSize: "clamp(38px, 5vw, 62px)",
    color: "#fff",
    fontWeight: 900,
    textShadow: "0 0 24px rgba(0,242,255,0.8)",
  },

  subtitle: {
    maxWidth: 820,
    margin: "0 auto 34px",
    color: "#9befff",
    fontSize: 21,
    lineHeight: 1.6,
  },

  demoBox: {
    maxWidth: 720,
    margin: "0 auto 28px",
    padding: 22,
    borderRadius: 26,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.35)",
    boxShadow: "0 0 35px rgba(0,242,255,0.16)",
    animation: "blockFlash 3s infinite",
    overflow: "hidden",
  },

  messageOne: {
    padding: "12px 16px",
    marginBottom: 12,
    borderRadius: 16,
    background: "rgba(0,242,255,0.08)",
    color: "#dffcff",
    animation: "messageMove 4s infinite",
  },

  messageTwo: {
    padding: "12px 16px",
    marginBottom: 12,
    borderRadius: 16,
    background: "rgba(255,60,90,0.12)",
    color: "#ffd5dc",
    animation: "messageMove 4s infinite 0.7s",
  },

  messageThree: {
    padding: "12px 16px",
    borderRadius: 16,
    background: "rgba(0,242,255,0.10)",
    color: "#00f2ff",
    fontWeight: 900,
    animation: "messageMove 4s infinite 1.4s",
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },

  card: {
    padding: 24,
    borderRadius: 24,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 24px rgba(0,242,255,0.10)",
  },

  cardIcon: {
    fontSize: 34,
    marginBottom: 12,
  },

  cardTitle: {
    margin: "0 0 10px",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
  },

  cardText: {
    margin: 0,
    color: "#9befff",
    fontSize: 15,
    lineHeight: 1.5,
  },
};
